import { getInitializeIntl, getUseIntl } from "@akina/presentation";

export const useInitializeIntl = getInitializeIntl.webshop;
export const useIntl = getUseIntl.webshop;
